import React, { FC } from 'react';

import {
  Stack,
  HStack,
  Text,
  OrderedList,
  ListItem,
  Link,
  Box,
  Image,
} from '@chakra-ui/react';
import { customTheme } from 'theme';

import { HelpCount } from 'components/DataDisplay/Utils/HelpCount';
import { ThirdPartyIcon } from 'components/Icons';

import AllFeaturesAreEnabled from './AllFeaturesAreEnabled.png';
import FullAWSAccessPolicy from './FullAWSAccessPolicy.png';

export const AutomaticOnboardingHelp: FC = () => {
  return (
    <Stack px={2} spacing={6} h="full">
      <Stack spacing={4}>
        <HStack align={'start'}>
          <HelpCount count={1} />
          <Text fontWeight={600}>Ensure that the following are true:</Text>
        </HStack>
        <OrderedList pl={12} spacing={1} color={customTheme.colors.gray['300']}>
          <ListItem pl={4}>
            <Stack>
              <Box>AWS Organization has ‘Enable All Features’</Box>
              <Box>
                <Image src={AllFeaturesAreEnabled} />
              </Box>
            </Stack>
          </ListItem>

          <ListItem pl={4}>
            <Stack>
              <Box>
                FullAWSAccess policy must be attached to OU for the onboarding
                to be successful
              </Box>
              <Box>
                <Image src={FullAWSAccessPolicy} />
              </Box>
            </Stack>
          </ListItem>
        </OrderedList>
      </Stack>
      <HStack align={'start'}>
        <HelpCount count={2} />
        <Stack spacing={4}>
          <HStack>
            <Text fontWeight={600}>Login to your AWS account</Text>
            <Link href="https://console.aws.amazon.com" target="_blank">
              <ThirdPartyIcon w={6} h={6} color="primary" />
            </Link>
          </HStack>
          <OrderedList
            pl={4}
            spacing={1}
            color={customTheme.colors.gray['300']}
          >
            <ListItem pl={4}>
              <Text>
                If onboarding root, copy the root ID{' '}
                <Text color="primary" display="inline">
                  (starts with r-)
                </Text>
              </Text>
            </ListItem>
            <ListItem pl={4}>
              <Text>
                If onboarding Organization Unit, copy the root ID{' '}
                <Text color="primary" display="inline">
                  (starts with ou-)
                </Text>
              </Text>
            </ListItem>
            <ListItem pl={4}>
              Enter the root ID or Organization Unit ID in the Cloud Formation
              template before kickstarting the Stack Set creation in AWS
            </ListItem>
          </OrderedList>
        </Stack>
      </HStack>
    </Stack>
  );
};
